import { StatsReportDataDetails } from "./stats-report.data.details";

export class StatsReportData {
  DATE: Date;
  TOTAL_REPORT: number;
  TOTAL_CLIENT: number;
  TOTAL_RELIANT: number;
  REPORTS: StatsReportDataDetails[];

  //Helpers
  COLLAPSE: boolean;


  constructor(value: any = {}) {
    Object.assign(this, value);

    this.COLLAPSE = false;

    if(value.REPORTS){
      this.REPORTS = StatsReportDataDetails.parseArray(value.REPORTS);
    }
  }

  static parseArray(json: any[]): StatsReportData[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new StatsReportData(j));

    return arr;
  }
}
